import { getContractOrgList } from '@/api/domain/organize'
import { operateMaxShowLength } from '@/store/dict/config'

const stateSource = {
  1: '启用',
  0: '停用',
  '-1': '未授权',
}

const expireStateSource = {
  0: '否',
  1: '是',
}

export default function () {
  const configData = {
    formData: {
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '企业主体全称',
            prop: 'orgName',
          },
          elConfig: {
            maxLength: 100,
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '统一社会信用代码证号',
            prop: 'orgIdCardNum',
          },
          elConfig: {
            maxLength: 18,
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: 'E签宝账号ID',
            prop: 'orgId',
          },
          elConfig: {
            maxLength: 32,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '授权是否即将过期',
            prop: 'expireState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(expireStateSource),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '状态',
            prop: 'state',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(stateSource),
            },
          },
        },
      ],
    },
    tableData: {
      columns: [
        {
          name: 'orgId',
          columnProps: {
            width: 300,
            prop: 'orgId',
            label: 'E签宝账号ID',
          },
        },
        {
          name: 'orgName',
          columnProps: {
            width: 300,
            prop: 'orgName',
            label: '企业主体全称',
          },
        },
        {
          name: 'orgIdCardNum',
          columnProps: {
            width: 200,
            prop: 'orgIdCardNum',
            label: '统一社会信用代码证号',
          },
        },
        {
          name: 'sealImage',
          columnProps: {
            prop: 'sealImage',
            label: '授权印章预览',
          },
          render: ({ row }) => {
            if (!row.sealImage) {
              return '--'
            }
            return this.$createElement('div', {}, [
              this.$createElement('el-popover', {
                props: {
                  placement: 'right',
                  trigger: 'hover',
                },
              }, [
                this.$createElement('img', {
                  attrs: {
                    src: row.sealImage,
                    class: 'preview-img',
                  },
                }),
                this.$createElement('img', {
                  slot: 'reference',
                  attrs: {
                    src: row.sealImage,
                    width: '50',
                    height: '50',
                  },
                }),
              ]),
            ])
          },
        },
        {
          name: 'expireTime',
          columnProps: {
            prop: 'expireTime',
            label: '授权失效日期',
          },
          render: ({ row }) => {
            return this.$createElement('div', [
              row.expireTime,
              row.expireState === 1 && this.$createElement('span', {
                style: {
                  color: 'red',
                },
              }, '(即将过期)'),
            ])
          },
        },
        {
          name: 'remainingQuantity',
          columnProps: {
            prop: 'remainingQuantity',
            label: '可签署份数',
          },
          columnHeaderTooltip: '数据可能存在5-10分钟延迟，注意不包含E签宝后台赠送的份数。',
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '状态',
          },
          render: ({ row }) => {
            if (row.state === -1) {
              return this.$createElement('div', { style: { color: 'red' } }, '未授权')
            }
            return this.$createElement('div', stateSource[row.state])
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const result = [
              {
                name: 'e_sign_auth',
                label: '授权',
                action: () => this.showAuth(row),
                permission: row.state === -1 && this.judgePermission('authBtn'),
              },
              {
                name: 'e_sign_detailList',
                label: '使用明细',
                action: () => this.detailList(row),
                permission: this.judgePermission('chargeRecord'),
              },
              {
                name: 'e_sign_enable',
                label: '启用',
                action: () => this.handleEnable(row),
                permission: row.state !== -1 && Number(row.state) === 0 && this.judgePermission('enableContractOrg'),
              },
              {
                name: 'purchase_record',
                label: '采购记录',
                action: () => this.purchaseRecord(row),
                permission: this.judgePermission('purchase_record'),
              },
              {
                name: 'e_sign_disable',
                label: '停用',
                action: () => this.handleDisable(row),
                permission: row.state !== -1 && Number(row.state) === 1 && this.judgePermission('disableContractOrg'),
              },
              {
                name: 'e_sign_renewal',
                label: '续期',
                action: () => this.handleRenewal(row),
                // expireState 1 为即将过期
                permission: row.expireState === 1 && this.judgePermission('renewalContractOrg'),
              },
            ]
            return result.filter((item) => item.permission)
          },
          type: 'operate',
        },
      ],
      apiFn: getContractOrgList,
    },
    isShowDepartment: false,
  }
  return configData
}
